const setupTooltip = () => {
  $('[data-toggle="tooltip"]').tooltip({ html: true });
};
global.setupTooltip = setupTooltip;
window.setupTooltip = setupTooltip;

document.addEventListener('turbolinks:load', function() {
  setupTooltip();
});
